/* eslint-disable import/prefer-default-export */
export enum CampaignTrackingEvent {
  Success = 'campaign_success',
  Duplicate = 'campaign_duplicate',
  Expired = 'campaign_expired',
  Error = 'campaign_error',
}
